// @vendors
const Immutable = require('immutable');

// @constants
const actionTypes = require('../raConstants/actionTypes');
const {
    BROKER_GET_MY_INVESTMENTS_SUCCESS,
    BROKER_GET_MY_INVESTMENTS_REQUEST,
    SIGNATURE_PATTERN_SMS_VALIDATION_FAILURE,
} = require('constants/actionTypes');

const initialState = Immutable.fromJS({
    isFetching: false,
    investmentsFetched: false,
    isLoading: false,
    submitSuccessful: false,
    valid: true,
});

const RACancelPlan = (state = initialState, action) => {
    switch (action.type) {
        case BROKER_GET_MY_INVESTMENTS_REQUEST:
            return state.set('isFetching', true);
        case BROKER_GET_MY_INVESTMENTS_SUCCESS:
            return state.merge({
                isFetching: false,
                investmentsFetched: true,
            });
        case actionTypes.RA_CANCEL_PLAN_IN_PROGRESS:
            return state.merge({
                isLoading: true,
            });
        case actionTypes.RA_CANCEL_PLAN_SUCCESS:
            return state.merge({
                submitSuccessful: true,
                isLoading: false,
            });
        case SIGNATURE_PATTERN_SMS_VALIDATION_FAILURE:
            return state.merge({
                isLoading: false,
            });
        case actionTypes.RA_CANCEL_PLAN_FAILURE:
            return state.merge({
                isLoading: false,
            });
        case actionTypes.RA_CANCEL_PLAN_RESET:
            return initialState;
        default:
            return state;
    }
};

module.exports = RACancelPlan;
